import Header from '../../components/Header/Header'

const About = () => {
    return (
        <div>
        </div>
    )
}

export default About